/* -------------------------------------------------------------------------- */
// Various helper functions used in custom exports/imports
/* -------------------------------------------------------------------------- */

export type CategoryMap = {
  labor: string;
  material: string;
  equip: string;
  sub: string;
  other: string;
  total: string;
};

export type CategoryKey = keyof CategoryMap;

const UNIT_COST_FIELDS: Array<[Exclude<CategoryKey, "total">, string]> = [
  ["labor", "labor_uc"],
  ["material", "material_uc"],
  ["equip", "equip_uc"],
  ["sub", "sub_uc"],
  ["other", "other_uc"],
];

/**
 * Which LMSEO buckets carry cost, falling back to `total` when all five are zero. Every export
 * shares this rule and differs only in what it maps the keys to.
 */
export function nonZeroCategories(row: any): Array<{ key: CategoryKey; unitCost: number }> {
  const nonZero = UNIT_COST_FIELDS.filter(([, field]) => row[field] !== 0);
  if (nonZero.length === 0) return [{ key: "total", unitCost: row.total_uc }];
  return nonZero.map(([key, field]) => ({ key, unitCost: row[field] }));
}

export function identifyCategory(row: any, map: CategoryMap): Array<[string, number]> {
  return nonZeroCategories(row).map(({ key, unitCost }) => [map[key], unitCost]);
}

export function formatDateForSage(d: Date = new Date()): string {
  const mm = String(d.getMonth() + 1).padStart(2, "0"); // 01-12
  const dd = String(d.getDate()).padStart(2, "0"); // 01-31
  return `${mm}${dd}${d.getFullYear()}`; // MMDDYYYY
}
